<template>
    <project-step-container
            prev-to="be_rapid_experiments_with_customers_21"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
    >
        <b-row>
            <b-col cols="12" class="main-text" tabindex="0">
               {{getMessage(22, 'rapidexperiment-sub')}}
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12" class="mt-3">
                <label for="first-thing"> {{getMessage(22, 'people')}}</label>
                <input id="first-thing" 
                :placeholder="getMessage(22, 'peopleplaceholder')" type="text" v-model="form.people"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="second-thing"> {{getMessage(22, 'worked')}}</label>
                <textarea id="second-thing" type="text" v-model="form.worked" rows="3"></textarea>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="third-thing"> {{getMessage(22, 'didntWork')}}</label>
                <textarea id="third-thing" type="text" v-model="form.didntWork" rows="3"></textarea>
            </b-col>
        </b-row>
    </project-step-container>
</template>

<script>
    import {Storage, Project, ConflictSyn} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import Steps from "../Utils/steps";

    export default {

        name: "RapidExperimentsWithCustomers22",
        components: {ProjectStepContainer},
        data() {
            return {
                step: Steps.FORM_DEBRIEF_EXPERIMENT,
                urlNextProject:'be_rapid_experiments_with_customers_23',
                form: {
                    people: "",
                    worked: "",
                    didntWork: ""
                }
            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>

